// see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/typeof

module.exports = Object.freeze({
  BIGINT: 'bigint',
  BOOLEAN: 'boolean',
  FUNCTION: 'function',
  NUMBER: 'number',
  OBJECT: 'object', // also null, arrays, and everything else that isn't one of the other types
  STRING: 'string',
  SYMBOL: 'symbol',
  UNDEFINED: 'undefined'
})
